module.exports = __webpack_public_path__ + "static/media/taximeter-mockup.5be02cf8.png";